export const SHOW_FLOOR_INDEX_FEATURE_KEY = 'sp-floor-index';
